export function unmaskPhoneNumber(phoneNumber) {
  if (phoneNumber) {
    return phoneNumber.replace("(", '').replace(")", '').replace(/-/g, '').replace(/\s+/g, '');
  }
}
